import React from "react";

import PublicUrlInput from "@admin/components/PublicUrlInput";
import Switch from "@admin/components/Switch";

type Props = {
    path?: string;
    publicUrl?: string;
    generateFromTitle: boolean;
    onGenerateFromTitleChange: (checked: boolean) => void;
};

export default function PageUrlEditor({ path, publicUrl, generateFromTitle, onGenerateFromTitleChange }: Props) {
    return (
        <>
            <PublicUrlInput
                name="path"
                defaultValue={path}
                publicUrl={publicUrl}
                readOnly={generateFromTitle}
                placeholder={generateFromTitle ? `Будет сформирован при сохранении` : undefined}
            />
            <Switch
                label="Формировать УРЛ из заголовка"
                name="generate_url_from_title"
                checked={generateFromTitle}
                onChange={(event) => onGenerateFromTitleChange(event.target.checked)}
                aria-describedby="page-url-hint"
                className={{ block: `mb-2` }}
            />
            <p id="page-url-hint" className="form-text mb-5">
                {generateFromTitle
                    ? `При изменении русского заголовка URL будет обновлён после сохранения.`
                    : `Изменение заголовка не меняет URL. При необходимости адрес можно изменить вручную.`}
            </p>
        </>
    );
}
